import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Link, useRouteMatch, Switch, Route } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import {
   Col,
   Row,
   Card,
   CardHeader,
   CardBody,
   CardTitle,
   Nav,
   NavItem,
   NavLink,
   Button,
   Badge,
   UncontrolledTooltip,
   Input
} from 'reactstrap'
import {
   exportInventory,
} from 'services/dataservice';
import ReactTable from "components/ReactTable/ReactTable.js";
import ReactBSAlert from 'react-bootstrap-sweetalert';
import Notify from 'react-notification-alert';
import moment from "moment";

import "./InventorySKUMovement.css";
import { getSKUMovement } from 'services/dataservice';
import { exportAllMovement } from 'services/dataservice';

export default function InventorySKUMovement(prop) {
   const { skuCode: skuCode_, mln: mln_, expiryDate: expiryDate_ } = prop.location.state || {};
   const [skuCode, setSKUCode] = useState(skuCode_ ?? "");
   const [mln, setMLN] = useState(mln_ ?? "");
   const [expiryDate, setExpiryDate] = useState(expiryDate_ ?? "");

   const columns = useMemo(() => [
      {
         Header: "Date",
         accessor: "date",
         style: { 'whiteSpace': 'unset' }
      },
      {
         Header: "SKU",
         accessor: "skuCode",
         disableFilters: false,
         // Cell: ({ row }) => <Link to={`${path}/detail/${row.original.inventoryId}`}>{row.original.inventorySKU}</Link>
      },
      {
         Header: "Product Name",
         accessor: "productName"
      },
      {
         Header: "Expiry Date",
         accessor: "expiryDate",
         style: { 'whiteSpace': 'unset' }
      },
      {
         Header: "MLN",
         accessor: "mln"
      },
      {
         Header: "Opening Balance",
         accessor: "opening",
         disableFilters: true
      },
      {
         Header: "In",
         accessor: "in",
         disableFilters: true
      },
      {
         Header: "Out",
         accessor: "out",
         disableFilters: true
      },
      {
         Header: "Closing Balance",
         accessor: "closing",
         disableFilters: true
      },
   ])

   const [filteredData, setFilteredData] = useState([])

   let { path, url } = useRouteMatch();
   const [alert, setAlert] = useState(null);
   const [tableData, setTableData] = useState([]);
   const [tabs, setTabs] = useState("all");
   const [statusCount, setStatusCount] = useState({ all: 0, stockAvailable: 0, outOfStock: 0, preOrder: 0, deleted: 0 });
   let history = useHistory();

   let currentDate = new Date();
   const [endDate, setEndDate] = useState(formatDateToYMD(new Date(currentDate)));
   const [startDate, setStartDate] = useState(
      formatDateToYMD(new Date(currentDate.setDate(currentDate.getDate() - 7)))
   );

   const notify = useRef(null);

   useEffect(() => {
      reloadList();
   }, []);

   function formatDateToYMD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
   }

   function reloadList() {
      if (Boolean(skuCode))
         getSKUMovement({ startDate, endDate, skuCode, mln, expiryDate }).then(res => {
            if (res.data) {
               setTableData(res.data.map((res, index) => {
                  return {
                     ...res
                  }
               }));
               setFilteredData(res.data.map((res, index) => {
                  return {
                     ...res
                  }
               }));
            }
         });
   }

   const triggerExport = async () => {
      const date = new Date()
      const dateStr = moment(date).format("YYYYMMDDHHmmss")
      const headers = columns.map(h => h.Header);

      const escapeCSV = (value) => {
         if (value == null) return '';
         const str = value.toString().replace(/"/g, '""');
         return /[",\n]/.test(str) ? `"${str}"` : str;
      };

      const rows = filteredData.map(row =>
         headers.map(h => {
            const key = columns.find(c => c.Header === h)?.accessor || h;
            return escapeCSV(row[key]);
         }).join(",")
      );
      const csvContent = [headers.join(","), ...rows].join("\n");

      const url = window.URL.createObjectURL(new Blob([csvContent], { type: "text/csv" }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Inventory_Movement_${dateStr}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

   }

   const triggerExportAll = async () => {
      let resp = await exportAllMovement({ startDate, endDate });
      const date = new Date()
      const dateStr = moment(date).format("YYYYMMDDHHmmss")

      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Inventory_All_Movement_${dateStr}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

   }

   return (
      <div className="content" style={{ "minWidth": "1200px" }}>
         {alert}
         <Notify ref={notify} />
         <Row className="row justify-content-end">
            <Col md="12" className="d-flex flex-row-reverse">
               {/* export all in date range */}
               <Button color="primary" onClick={triggerExportAll}>Export All Inventory</Button>
               <Button color="primary" onClick={triggerExport}>Export</Button>
            </Col>
         </Row>
         <Row>
            <Col md="12">
               <Card className="card-subcategories">
                  <CardHeader>
                     <CardTitle tag="h4">Inventory Movement</CardTitle>
                  </CardHeader>
                  <CardBody>
                     <div>
                        <Row>
                           <Col md="6">
                              <Input
                                 placeholder="Search By SKU (max 10 SKU, separated by comma)"
                                 value={skuCode}
                                 onChange={(e) => {
                                    setSKUCode(e.target.value)
                                    setMLN("")
                                    setExpiryDate("")
                                 }
                                 }
                              ></Input>
                           </Col>
                        </Row>
                        <Row>
                           <Col md="6">
                              <Input type="date" placeholder="Start Date" value={startDate} onChange={(e) => setStartDate(e.target.value)} ></Input>
                           </Col>
                        </Row>
                        <Row>
                           <Col md="6">
                              <Input type="date" placeholder="End Date" value={endDate} onChange={(e) => setEndDate(e.target.value)} ></Input>
                           </Col>
                        </Row>
                        <Row>
                           <Col md="6">
                              <Button color="primary" disabled={!Boolean(skuCode)} onClick={reloadList}>Apply</Button>
                           </Col>
                        </Row>
                     </div>
                     <ReactTable
                        data={tableData}
                        columns={columns}
                        setFilteredData={setFilteredData}
                        className="-striped -highlight primary-pagination">
                     </ReactTable>
                  </CardBody>
               </Card>
            </Col>
         </Row>
      </div >
   )
}